class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    this.addEventListener('slider:change', () => {
      const slider = document.querySelector('.dual-range-slider');
      if (!slider) return;

      const minSlider = slider.querySelector('.range-min');
      const maxSlider = slider.querySelector('.range-max');
      const minParam = slider.dataset.minParam;
      const maxParam = slider.dataset.maxParam;

      if (!minSlider || !maxSlider || !minParam || !maxParam) return;

      const params = new URLSearchParams(FacetFiltersForm.searchParamsPrev);
      params.delete(minParam);
      params.delete(maxParam);

      const minVal = Math.round(+minSlider.value * 100);
      const maxVal = Math.round(+maxSlider.value * 100);
      const absMax = Math.round(+minSlider.max * 100);

      if (minVal > 0) params.set(minParam, minVal);
      if (maxVal < absMax) params.set(maxParam, maxVal);

      FacetFiltersForm.renderPage(params.toString(), null, true);
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));

    const productGrid = document.getElementById('ProductGridContainer');
    if (productGrid) {
      const collection = productGrid.querySelector('.collection');
      if (collection) collection.classList.add('loading');
    }

    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function')
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function')
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const newGrid = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer');
    if (!newGrid) return;

    document.getElementById('ProductGridContainer').innerHTML = newGrid.innerHTML;
    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => element.classList.add('scroll-trigger--cancel'));
  }

  static renderProductCount(html) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

  const countContainer = document.getElementById('ProductCount');
  const countContainerDesktop = document.getElementById('ProductCountDesktop');

  const parsedCount = parsedHTML.getElementById('ProductCount');
  const parsedCountDesktop = parsedHTML.getElementById('ProductCountDesktop');

  if (parsedCount && countContainer) {
    countContainer.innerHTML = parsedCount.innerHTML;
    countContainer.classList.remove('loading');
  }

  if (parsedCountDesktop && countContainerDesktop) {
    countContainerDesktop.innerHTML = parsedCountDesktop.innerHTML;
    countContainerDesktop.classList.remove('loading');
  }

  const currentProductCountRows = document.querySelectorAll('.product-count--with-clear');
  const newProductCountRows = parsedHTML.querySelectorAll('.product-count--with-clear');

  currentProductCountRows.forEach((row, index) => {
    if (newProductCountRows[index]) {
      row.innerHTML = newProductCountRows[index].innerHTML;
    }
  });

  const currentVerticalProductCount = document.querySelector('.product-count-vertical');
  const newVerticalProductCount = parsedHTML.querySelector('.product-count-vertical');

  if (currentVerticalProductCount && newVerticalProductCount) {
    currentVerticalProductCount.innerHTML = newVerticalProductCount.innerHTML;
  }

  document
    .querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner')
    .forEach((spinner) => spinner.classList.add('hidden'));
}

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }
        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event?.target.closest('.js-filter')?.id;
      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? '.mobile-facets__close-button'
          : '.facets__summary';
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        const isTextInput = event.target.getAttribute('type') === 'text';
        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    if (typeof initDualRangeSlider === 'function') initDualRangeSlider();
    initMobileSortSheet();
    initCustomSortDropdowns();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const domElement = document.querySelector(selector);
      if (domElement) domElement.innerHTML = activeFacetsElement.innerHTML;
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
  '.mobile-facets__open',
  '.mobile-facets__count',
  '.mobile-facets__count-row',
  '.mobile-facets__active-tags',
  '.product-count--with-clear',
  '.sorting',
];

    mobileElementSelectors.forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!source || !target) return;
      target.innerHTML = source.innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const drawer = mobileForm.closest('menu-drawer');
      if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');
    if (sourceSummary && targetSummary) targetSummary.outerHTML = sourceSummary.outerHTML;

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');
    if (sourceHeaderElement && targetHeaderElement)
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');
    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector('show-more-button .label-show-more.hidden')
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');
    if (sourceFacetsList && targetFacetsList)
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`
    );
  }

  static getSections() {
    return [{ section: document.getElementById('product-grid').dataset.id }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    document.querySelectorAll('.dual-range-slider').forEach((slider) => {
      const minParam = slider.dataset.minParam;
      const maxParam = slider.dataset.maxParam;
      if (minParam) formData.delete(minParam);
      if (maxParam) formData.delete(maxParam);
    });

    document.querySelectorAll('.dual-range-slider').forEach((slider) => {
      const minSlider = slider.querySelector('.range-min');
      const maxSlider = slider.querySelector('.range-max');
      const minParam = slider.dataset.minParam;
      const maxParam = slider.dataset.maxParam;

      if (!minSlider || !maxSlider || !minParam || !maxParam) return;

      const minVal = Math.round(+minSlider.value * 100);
      const maxVal = Math.round(+maxSlider.value * 100);
      const absMax = Math.round(+minSlider.max * 100);

      if (minVal > 0) formData.set(minParam, minVal);
      if (maxVal < absMax) formData.set(maxParam, maxVal);
    });

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
  event.preventDefault();

  const forms = [];
  const currentForm = event.target.closest('form');
  const isMobile =
    currentForm?.id === 'FacetFiltersFormMobile' ||
    currentForm?.id === 'FacetSortMobileForm';

  document.querySelectorAll('facet-filters-form form').forEach((form) => {
    if (isMobile) {
      if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortMobileForm') {
        forms.push(this.createSearchParams(form));
      }
    } else if (
      form.id === 'FacetSortForm' ||
      form.id === 'FacetFiltersForm' ||
      form.id === 'FacetSortDrawerForm'
    ) {
      forms.push(this.createSearchParams(form));
    }
  });

  this.onSubmitForm(forms.join('&'), event);
}


  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') === -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const firstInput = inputs[0];
    const secondInput = inputs[1];
    if (secondInput.value) firstInput.setAttribute('max', secondInput.value);
    if (firstInput.value) secondInput.setAttribute('min', firstInput.value);
    if (firstInput.value === '') secondInput.setAttribute('min', 0);
    if (secondInput.value === '') firstInput.setAttribute('max', secondInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  onKeyDown(event) {
    if (event.metaKey) return;
    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowRight|ArrowLeft|ArrowUp|ArrowDown|Delete|Escape/;
    if (!pattern.test(event.key)) event.preventDefault();
  }
}


function initSingleRangeSlider() {
  document.querySelectorAll('.single-range-slider').forEach((slider) => {
    const input = slider.querySelector('.range-max-single');
    const valDisplay = slider.querySelector('.single-range-val');
    const maxParam = slider.dataset.maxParam;

    if (!input || !maxParam || slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';

    const syncDisplay = () => {
      if (valDisplay) valDisplay.textContent = Number(input.value).toLocaleString('en-IN');
    };

    syncDisplay();

    input.addEventListener('input', syncDisplay);

    input.addEventListener('change', () => {
      const facetForm = document.querySelector('#FacetFiltersForm');
      if (!facetForm) return;

      let hidden = facetForm.querySelector(`input[name="${CSS.escape(maxParam)}"]`);
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = maxParam;
        facetForm.appendChild(hidden);
      }

      const maxVal = Math.round(Number(input.value) * 100);
      const absMax = Math.round(Number(input.max) * 100);

      hidden.value = maxVal < absMax ? String(maxVal) : '';

      facetForm.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });
}

document.addEventListener('DOMContentLoaded', initSingleRangeSlider);

const originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;
FacetFiltersForm.renderProductGridContainer = function(html) {
  originalRenderProductGridContainer.call(this, html);
  setTimeout(initSingleRangeSlider, 50);
};

function initCustomSortDropdowns() {
  document.querySelectorAll('.custom-sort').forEach((sort) => {
    if (sort.dataset.initialized) return;
    sort.dataset.initialized = 'true';

    const button = sort.querySelector('.sort-btn');
    const select = sort.querySelector('.custom-sort__select');
    const items = sort.querySelectorAll('.sort-dropdown__item');

    if (!button || !select) return;

    button.addEventListener('click', () => {
      const isOpen = sort.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(isOpen));
    });

    items.forEach((item) => {
      item.addEventListener('click', () => {
        select.value = item.dataset.value;
        sort.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initCustomSortDropdowns);

document.addEventListener('click', (event) => {
  document.querySelectorAll('.custom-sort.is-open').forEach((sort) => {
    if (!sort.contains(event.target)) {
      sort.classList.remove('is-open');
      const button = sort.querySelector('.sort-btn');
      if (button) button.setAttribute('aria-expanded', 'false');
    }
  });
});

function initMobileSortSheet() {
  document.querySelectorAll('.mobile-sort__option').forEach((button) => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = 'true';

    button.addEventListener('click', () => {
      const form = button.closest('form');
      const select = form?.querySelector('.mobile-sort__select');
      const details = button.closest('.mobile-sort__details');

      if (!select) return;

      select.value = button.dataset.value;
      if (details) details.removeAttribute('open');

      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('.mobile-sort__backdrop').forEach((backdrop) => {
    if (backdrop.dataset.initialized) return;
    backdrop.dataset.initialized = 'true';

    backdrop.addEventListener('click', () => {
      backdrop.closest('.mobile-sort__details')?.removeAttribute('open');
    });
  });
}

document.addEventListener('DOMContentLoaded', initMobileSortSheet);
